import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename: 'Me', id: string, displayName: string, email: string, tenantId: string, permissions: { __typename: 'UserPermission', isSuperAdmin: boolean, roles: Array<string>, scopes: Array<string> }, storeSetting?: { __typename?: 'UserTenantStoreSetting', isStoreOwnerTenant: boolean } | null, tenants: Array<{ __typename: 'UserTenantItem', id: string, tenantName: string, isCurrentTenant: boolean, isHomeTenant: boolean, isRootTenant: boolean }> } | null };


export type ExecGetMeOptions = Omit<
  Apollo.QueryOptions<GetMeQueryVariables, GetMeQuery>,
  "query"
  >;
export const execGetMeQuery = (options: ExecGetMeOptions) =>
  client.query<GetMeQuery, GetMeQueryVariables>({
    ...options,
    query: GetMeDocument,
  });
    

export const GetMeDocument = gql`
    query getMe {
  me {
    id
    displayName
    email
    tenantId
    permissions {
      isSuperAdmin
      roles
      scopes
      __typename
    }
    storeSetting {
      isStoreOwnerTenant
    }
    tenants {
      id
      tenantName
      isCurrentTenant
      isHomeTenant
      isRootTenant
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
  export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;